<template>
  <div class="wrap">
    <NewsArticle  v-for="(item, key) in this.$store.getters.newsArticles"
                  v-bind:key="key"
                  v-bind:title="item.title"
                  v-bind:contents="item.contents"
                  v-bind:date="item.date"
                  v-bind:author="item.author"
                  v-bind:tags="item.tags"
                  />
  </div>
</template>

<script>
import NewsArticle from '../elements/NewsArticle'
export default {
  name: 'News',
  data () {
    return {
      // mode: 'login' // login/register
    }
  },
  props: [],
  components: {
    NewsArticle
  },
  methods: {

  },
  computed: {

  },
  created () {
    this.$store.dispatch('getNews', {}).then(() => {
      console.log('Got news')
      // this.getUserData()
    })
  }
}
</script>

<style scoped lang="scss">
.wrap {
  width: 580px;
  margin-right: 200px;
}
</style>
